/* eslint-disable */
export const initFBEvents = () => {
  !function(f,b,e,v,n,t,s) {
    if (f.fbq) return; n = f.fbq = function () {
      n.callMethod ?
        n.callMethod(...arguments) : n.queue.push(arguments);
    };
    if (!f._fbq)f._fbq = n; n.push = n; n.loaded = !0; n.version = '10.0';
    n.queue = []; t = b.createElement(e); t.async = !0;
    t.src = v; s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  }(
    window, document, 'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  );
  window.fbq('init', '1537687209652778');
  window.fbq('track', 'PageView');
};

export const logFacebookEvent = (eventName, params) => {
  window.fbq('trackCustom', eventName, params);
}

export const initFBSdk = () => {
  window.fbAsyncInit = function () {
    window.FB.init({
      appId: 137044017010163,
      autoLogAppEvents: true,
      xfbml: false,
      version: 'v10.0',
      status: false,
    });
    window.fbInitialized = true;
    if (window.fbInitializedFunc) {
      window.fbInitializedFunc();
    }
  };
  (function (d, s, id) {
    let js,
      fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) { return; }
    js = d.createElement(s); js.id = id;
    js.src = 'https://connect.facebook.net/en_US/sdk.js';
    fjs.parentNode.insertBefore(js, fjs);
  }(document, 'script', 'facebook-jssdk'));
};
/* eslint-enable */
